import React, { Component } from 'react'
import '../styles/PopIn.css'

class PopIn extends Component {
  render() {
    return (
      <div className="pop-in">
        {
          this.props.small
          ?
            <div className={`pop-in-inner pop-in-inner--small ${this.props.klass}`}>
                <div className="pop-in-close pop-in-close--small" onClick={this.props.closePopIn}></div>
              {this.props.children}
            </div>
          :
            <div className={`pop-in-inner ${this.props.klass || ''}`}>
              <div className="pop-in-header">
                <div className="pop-in-title">{this.props.title}</div>
                <div className="pop-in-close" onClick={this.props.closePopIn}></div>
              </div>
              {this.props.children}
            </div>
        }
      </div>
    )
  }
}

export default PopIn



// WEBPACK FOOTER //
// ./src/components/PopIn.js